import {
  LockIcon,
  ZapIcon,
  CreditCardIcon,
  SmartphoneIcon,
  HomeIcon,
  MessageSquareIcon,
  MessagesSquareIcon,
  MailIcon,
  CalendarDaysIcon,
  HandshakeIcon,
  BarChart3Icon,
} from 'lucide-react';

export const offer = {
  was: '$54',
  now: '27',
  saved: '$27',
  idealFor: ['REALTORS®', 'Real Estate Agents', 'Brokers', 'Independent Agents', 'Real Estate Professionals'],
};

export const packageIncludes = [
  'Full 6-Volume REALTOR® AI System',
  '100 specialized AI prompts',
  'Lead generation workflows',
  'Listing & property marketing workflows',
  'Lead conversion frameworks',
  'Objection & negotiation prompts',
  'Follow-up & CRM workflows',
  'REALTOR® authority & content prompts',
  '5 professional bonuses',
  'Instant digital access',
  'Mobile & tablet compatible',
  'Lifetime access',
];

export const trustItems = [
  { icon: LockIcon, label: 'Secure Payment' },
  { icon: ZapIcon, label: 'Instant Access' },
  { icon: CreditCardIcon, label: 'Credit / Debit' },
  { icon: SmartphoneIcon, label: 'Mobile & Tablet' },
];

export const toolkitBonuses = [
  'Quick-Start Vault',
  '30-Day Content Calendar',
  'Follow-Up Message Vault',
  'Open House Profit Kit',
  'AI Command Center',
];

export const useCases = [
  { icon: HomeIcon, label: 'Preparing a listing' },
  { icon: MessageSquareIcon, label: 'Responding to a lead' },
  { icon: MessagesSquareIcon, label: 'Handling an objection' },
  { icon: MailIcon, label: 'Building a follow-up sequence' },
  { icon: CalendarDaysIcon, label: 'Planning content' },
  { icon: HandshakeIcon, label: 'Preparing for a client conversation' },
  { icon: BarChart3Icon, label: 'Organizing your CRM' },
];

export const finalSummary = ['100 AI Prompts', '6 Strategic Volumes', '5 Professional Bonuses', 'Instant Digital Access', 'Lifetime Access'];
